export const VARIANTS = ['default', 'success', 'error'] as const;
export type VariantType = (typeof VARIANTS)[number];

export const ICON_VARIANTS = ['default', 'primary'] as const;
export type IconVariantType = (typeof ICON_VARIANTS)[number];

export type InputError = {
  hasError?: boolean;
  label?: string;
};
